import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { question_circle, unimel_icon } from '../assets';
import { AuthContext } from '../context/AuthContext';
import useAdministrationAccess from '../hooks/useAdministrationAccess';

const Header = ({ onBeforeLogout }) => {
  const { user, course, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const { session } = useAdministrationAccess();

  const handleLogout = () => {
    if (onBeforeLogout && !onBeforeLogout()) return;
    logout();           // Limpia el contexto y localStorage
    navigate('/login'); // Redirige al login
  };

  return (
    <header className="top-0 w-full flex flex-wrap gap-3 items-center justify-between p-4 bg-white font-Inter border-b shadow-md z-10">
      {/* Left Section */}
      <div className="flex items-center">
        <img
          src={unimel_icon}
          alt="Logo"
          className="h-12 mr-4"
        />
        <p className="text-[#D69D0B] font-medium text-lg">Asistente Legal para Chile</p>
      </div>

      {/* Right Section */}
      <div className="flex flex-wrap items-center gap-3">
        {session?.canAdminister && (
          <Link to="/administracion" className="text-blue-700 underline font-medium">Administración</Link>
        )}
        <div className="text-[#D69D0B] text-lg flex items-center">
          {course?.["NOMBRELARGOCURSO"] && (
            <>
              <span className="mr-2">{course["NOMBRELARGOCURSO"]}</span>
              <span className="mx-2 text-gray-400">-----</span>
            </>
          )}
          {user ? user['Nombre Alumno'] || user.username : 'USUARIO'}
        </div>

        {/* Botón de ayuda (icono) */}
        <div className="text-[#767676] flex items-center">
          <img src={question_circle} alt="Help" className="h-6" />
        </div>

        {/* Botón cerrar sesión */}
        <button
          onClick={handleLogout}
          className="ml-4 px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
        >
          Cerrar sesión
        </button>
      </div>
    </header>
  );
};

export default Header;
